import { BufOrStr } from '../types';
import { isNum } from '../utils/common';
import { getHistoAndBasicAggs } from './getHistoAndBasicAggs';
import { HistoSummary, LineEnding, StringBufInfo } from './getStrbufSummary.types';

const enum Controls {
	Cr = 0x0d,
	Lf = 0x0a,
}

export function checkHisto(histo: number[], start: number, end: number): boolean {
	start = Math.max(start, 0);
	end = Math.max(start, end);

	for (let i = start; i <= end; ++i) {
		const val = histo[i];
		if (isNum(val) && val > 0) {
			return true;
		}
	}

	return false;
}

export function summarizeHisto(histo: number[]): HistoSummary {
	const hasNull = checkHisto(histo, 0, 0);
	const hasControl1 = checkHisto(histo, 0x01, 0x07);
	const hasBackspace = checkHisto(histo, 0x08, 0x08);
	const hasTab = checkHisto(histo, 0x09, 0x09);
	const hasLf = checkHisto(histo, 0x0a, 0x0a);
	const hasControl2 = checkHisto(histo, 0x0b, 0x0c);
	const hasCr = checkHisto(histo, 0x0d, 0x0d);
	const hasControl3 = checkHisto(histo, 0x0e, 0x1f);
	const hasDel = checkHisto(histo, 0x7f, 0x7f);
	const hasHigh = checkHisto(histo, 0x80, 0xff);

	const hasControl = hasControl1 || hasBackspace || hasControl2 || hasControl3 || hasDel;

	return {
		hasNull,
		hasControl1,
		hasBackspace,
		hasTab,
		hasLf,
		hasControl2,
		hasCr,
		hasControl3,
		hasDel,
		hasHigh,
		hasControl,
		allNonNull: !hasNull,
		allAsciiPrintable: !hasNull && !hasControl && !hasHigh && !hasCr && !hasLf,
		allAsciiPrintableCrLf: !hasNull && !hasControl && !hasHigh,
		allAsciiPrintableCrLfNull: !hasControl && !hasHigh,
		allAscii: !hasHigh,
	};
}

export function getStrbufSummary(bufOrBufs: BufOrStr | BufOrStr[]): StringBufInfo {
	const aggs = getHistoAndBasicAggs(bufOrBufs);

	const s = summarizeHisto(aggs.histo);

	const histo = aggs.histo;

	let lineEnding: LineEnding = LineEnding.Unknown;
	if (histo[Controls.Cr] > 0 && histo[Controls.Cr] === histo[Controls.Lf]) {
		lineEnding = LineEnding.Crlf;
	} else if (histo[Controls.Lf] > 0 && histo[Controls.Cr] === 0) {
		lineEnding = LineEnding.Lf;
	} else if (histo[Controls.Cr] === 0 && histo[Controls.Lf] === 0) {
		lineEnding = LineEnding.None;
	}

	const aggs2: StringBufInfo = {
		...aggs,
		...s,
		lineEnding: lineEnding,
	};
	return aggs2;
}
